// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { FooterComponent, TitleComponent } from '@openbank/ziniaweb-ui-components';
import { SuccessDescriptionComponent } from './components/description/success-description.component';
// Constants
import {
  SUCCESS_FOOTER_BUTTON_PROPS,
  SUCCESS_FOOTER_PROPS,
  SUCCESS_SUBTITLE_PROPS,
  SUCCESS_TITLE_PROPS,
} from './constants/success.constants';
// Hooks
import { useSuccessHook } from './hooks/success.hook';
// Styles
import { SuccessContainerStyled, SuccessHeaderStyled } from './success.container.styled';
// Translations
import { BUTTON, DEFAULTS, DESCRIPTIONS, TITLES } from './translations/success.translations';

const SuccessContainer = (): React.JSX.Element => {
  const {
    customerName = 'Mrs / Miss',
    handleRedirectSuccessToAmazonButtonClick,
    currentState,
  } = useSuccessHook();

  return (
    <SuccessContainerStyled>
      <SuccessHeaderStyled>
        <TitleComponent
          {...SUCCESS_TITLE_PROPS}
          title={
            <FormattedMessage
              id={TITLES[currentState] || DEFAULTS.TITLE}
              values={{ customerName }}
            />
          }
        />
        <TitleComponent
          {...SUCCESS_SUBTITLE_PROPS}
          title={<FormattedMessage id={DESCRIPTIONS[currentState] || DEFAULTS.DESCRIPTION} />}
        />
      </SuccessHeaderStyled>
      <SuccessDescriptionComponent />
      <FooterComponent
        {...SUCCESS_FOOTER_PROPS}
        mainButtonConfiguration={{
          ...SUCCESS_FOOTER_BUTTON_PROPS,
          children: <FormattedMessage id={BUTTON} />,
          onClick: handleRedirectSuccessToAmazonButtonClick,
        }}
      />
    </SuccessContainerStyled>
  );
};

export { SuccessContainer };
